import { OverlayPage } from '@client/components/_core/layout/OverlayPage';
import { PageController } from '@client/components/_core/layout/PageController';
import { SMSMessageForm } from '@client/components/claims/new-message/SMSMessageForm';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { claimFormStore } from '../../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/comms/add/sms')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Send SMS',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <SMSCommLogAdd />
        </PageController>
    );
}

function SMSCommLogAdd() {
    const claim = claimFormStore.use.formData();
    const { trpcUtils } = useTrpc();
    const navigate = useNavigate();

    return (
        <OverlayPage
            size="middle"
            title="Send SMS"
            afterClose={() => {
                void trpcUtils.communication.listCommLogAndNotes.invalidate({ claimId: claim.id });
                void trpcUtils.claim.getClaimClientUpdateSummary.invalidate({ id: claim.id });
                navigate({ moveInMatches: -1 });
            }}
        >
            {({ onClose }) => <SMSMessageForm claimId={claim.id} onClose={onClose} />}
        </OverlayPage>
    );
}
